<!--
Component for the more features carousel.
@author crm4f
-->
<template>
  <div class="moreFtrsCarouselContainer">
    <HomepageCarousel v-if="ftrs.length" name="moreFtrs" :isPrimary="1!==1">
      <CarouselItem v-bind:key="index" v-for="(ftr, index) in ftrs" :id ="'moreFtrs' + index">
          <div class="moreFtrsItemContainer">
            <p class="ftrText" v-html="ftr.content"></p>
            <img class="ftrImg" :id ="ftr + 'Img'" :src="getImage(ftr)"/><br>
            <ViewMoreButton :text="ftr.title" :featureLink="ftr.path" :isPrimary="1!==1"></ViewMoreButton>
          </div>
      </CarouselItem>
    </HomepageCarousel>
  </div>
</template>

<script setup>
import HomepageCarousel from '@/components/homepage/HomepageCarousel.vue'
import CarouselItem from '@/components/homepage/CarouselItem.vue'
import ViewMoreButton from '@/components/homepage/ViewMoreButton.vue'
import { ref, onMounted } from 'vue'
import axios from 'axios'

const ftrs = ref([])


onMounted (() => {
    fetchItems()
    console.log(ftrs.value)
  })

    function getImage(ftr) {
      try {
        let img = require('../../assets/' + titleNameToImg(ftr.title))
        return img
      } catch {
        console.error('img no found')
        handleImageError(ftr)
      }
      
    }
    function handleImageError(ftr) {
      const index = ftrs.value.indexOf(ftr)
      if (index > -1) { // only splice array when item is found
        ftrs.value.splice(index, 1); // 2nd parameter means remove one item only
      }
    }

    function titleNameToImg (title) {
      return title.trim().toLowerCase().replaceAll(' ', '-') + '-hmpg.svg'
    }
    
    function fetchItems () {
      axios.get('/timetable/slides/all', {})
        .then(response => {
          console.log(response.data)
          let items = response.data.carouselItems
          if (typeof items !== 'undefined' && items.length > 0) {
            ftrs.value = []
            items.map((item) => {
              ftrs.value.push({ title: item.title, content: item.content, path: item.path })
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
</script>

<style lang="scss" scoped>
.moreFtrsItemContainer {
  display:flex;
  flex-flow:column wrap;
  width:100%;
}

.ftrText {
  color:#fff;
  margin-bottom:0px !important;
  white-space: pre-line;
}

.ftrImg {
  margin-top: 10px;
  width: fit-content;
  align-self: center;
  width: 250px;
  height: 200px;
}

</style>
